import { Badge } from '@shared/components/ui/badge';
import type { AccountingSyncStatus } from '../models';
import type { TFunction } from 'i18next';

export const getAccountingSyncStatusBadge = (status: AccountingSyncStatus, t: TFunction<'accountingSyncModule'>) => {
  const map: Record<
    AccountingSyncStatus,
    { variant: 'default' | 'destructive' | 'secondary' | 'outline' | 'transparent-green' | 'transparent-orange' }
  > = {
    pending: { variant: 'secondary' },
    synced: { variant: 'transparent-green' },
    failed: { variant: 'destructive' },
    skipped: { variant: 'transparent-orange' },
  };
  const config = map[status] ?? map.pending;
  const labelKey = `status.${status}` as const;
  return (
    <Badge variant={config.variant} className="text-xs whitespace-nowrap">
      {t(labelKey)}
    </Badge>
  );
};
